import React from 'react';
import {Input, RemoveButton, RequiredButton} from '../../ui';
import {useRemoveField, useToggleRequired} from '../../model';
import {setFields} from '../../service/createForm.slice';
import {useDispatch} from 'react-redux';
import {ConditionIcon, ImageIcon} from '../../icons';
import {useLocation} from 'react-router-dom';
import {useTranslation} from '../../../../hooks/useTranslation';
function ImageField({field, idx}) {
  const dispatch = useDispatch();
  const location = useLocation();
  let isReadOnly = Boolean(location.search.split('=')[1]);

  const {removeField} = useRemoveField();
  const {toggleRequired} = useToggleRequired();
  const {t} = useTranslation();
  const handleRequired = () => toggleRequired(idx);

  const handleChange = e => {
    dispatch(
      setFields({
        index: idx,
        key: 'label',
        value: e.target.value,
      }),
    );
  };
  const handleRemove = () => removeField(idx);

  return (
    <div className='f-build__general'>
      <div className='f-build__general-header'>
        <Input
          onChange={handleChange}
          label={t('createNewForm.components.fieldName')}
          placeholder={t('createNewForm.components.enterFieldName')}
          value={field?.label}
          disabled={isReadOnly}
        />
        {!isReadOnly && (
          <div className='f-build__general-actions'>
            <RequiredButton
              key={'input-required'}
              idx={idx}
              id={'input-required'}
              required={field?.required}
              handleRequired={handleRequired}
            />
            <RemoveButton
              key={'condition-remove'}
              idx={idx}
              id={'condition'}
              handleRemove={handleRemove}
            />
          </div>
        )}
      </div>
      <div className='f-build__general-type'>
        <ImageIcon />
        <span>{t('createNewForm.components.uploadImage')}</span>
      </div>
    </div>
  );
}

export default ImageField;
